import Vivus from 'vivus';
import vars from '../helpers';

function init() {
	let $graph = vars.$body.find('.svg svg');
	let $arrow = vars.$body.find('.share__up svg');
	let introSvg = vars.$body.find('.intro__svg.intro__svg--3 svg');

	if (vars.isIE()) {
		return;
	}

	$graph.each((index, graph) => {
		let graphVivus = new Vivus(graph,
			{
				type: 'delayed',
				duration: 300,
				animTimingFunction: Vivus.EASE_OUT,
			},
		);
	});

	$arrow.on('mouseenter', () => {
		$arrow.each((index, graph) => {
			let graphVivus = new Vivus(graph,
				{
					type: 'oneByOne',
					duration: 300,
					animTimingFunction: Vivus.EASE_OUT,
				},
			);
			graphVivus.stop()
				.reset()
				.play(2);
		});
	});

	introSvg.each((index, graph) => {
		if (vars.isMobile()) {
			setTimeout(() => {
				$('.intro__svg.intro__svg--3').removeClass('is-hidden');

				let graphVivus = new Vivus(graph,
					{
						type: 'delayed',
						duration: 300,
						animTimingFunction: Vivus.EASE_OUT,
					},
				);
			}, 1950);
		} else {
			setTimeout(() => {
				$('.intro__svg.intro__svg--3').removeClass('is-hidden');

				let graphVivus = new Vivus(graph,
					{
						type: 'delayed',
						duration: 300,
						animTimingFunction: Vivus.EASE_OUT,
					},
				);
			}, 1300)
		}
	});

	$arrow.on('click', () => {
		vars.scrollTo($('body'), 3000, 0)
	})
}

export default {
	init,
};
